import { iots } from '@code-expert/prelude';
import { CourseUrl, SemesterId } from '/imports/domain';
import { end, formatRoute, lit, query, type, url } from '/imports/modules/Routing';
import { Page } from './pages';

export const enroledSlug = 'enrolled';

const pageSlug = (p: Page) => url(base, lit(p));

const enroled = lit(enroledSlug);
const semester = type('semester', SemesterId);
const courseUrl = type('courseUrl', CourseUrl);
const page = type('page', Page);

export const enroledRoute = url(enroled, end);

const base = url(enroled, semester, courseUrl);

export const enroledCourseRoute = url(base, end);
export const enroledCourseRouteWithPage = url(base, page, end);

const analyticsQuery = query(iots.exact(iots.partial({ highscoreChartSection: iots.string })));

export const enroledAnalyticsRoute = url(pageSlug('analytics'), analyticsQuery, end);
export const enroledCodeExamplesRoute = url(pageSlug('codeExamples'), end);
export const enroledExercisesRoute = url(pageSlug('exercises'), end);
export const enroledGroupsRoute = url(pageSlug('groups'), end);

export const enroledAnalyticsLink = formatRoute(enroledAnalyticsRoute);
export const courseEntryLink = formatRoute(enroledCourseRoute);
export const enroledExercisesLink = formatRoute(enroledExercisesRoute);
export const coursePageLink = formatRoute(enroledCourseRouteWithPage);
